import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSBenutzer from '../../../models/TSBenutzer';
import {IAnlaufstelleBenutzerEditStateParams} from '../../benutzerverwaltung.route';
import './benutzerEditAnlaufstelleView.scss';
import ILogService = angular.ILogService;
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./benutzerEditAnlaufstelleView.html');

/**
 * Diese Komponente diente dazu Benutzer einer bestimmten Anlaufstelle zu editieren, wahrscheinlich ist dies
 * nun gar nicht mehr noetig da wir die Benutzerverwaltung separat fuehren.
 * Diese component kann somit erstmal als deprecated betrachtet werden. Allenfalls koennen wir sie spaeter auch loeschen
 * @deprecated
 */
export class BenutzerEditAnlaufstelleComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerEditAnlaufstelleViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        anlaufstelle: '<',
        benutzer: '<',
        sachbearbeiterList: '<',
        schaetzerList: '<'
    };
}

export class BenutzerEditAnlaufstelleViewController extends AbstractGesuchViewController<TSBenutzer> {

    private anlaufstelle: TSAnlaufstelle;
    private benutzer: TSBenutzer;
    private tempRole: TSRole;

    private sachbearbeiterList: Array<TSBenutzer>;
    private schaetzerList: Array<TSBenutzer>;

    private viewReadonly: boolean = false;

    static $inject: string[] = ['$stateParams', 'AnlaufstelleRS', '$log', 'ErrorService', '$window', '$state',
        'PasswordStrengthService', '$scope', 'RoleUtilService', '$translate', 'BenutzerRS'];

    /* @ngInject */
    constructor(private $stateParams: IAnlaufstelleBenutzerEditStateParams, private anlaufstelleRS: AnlaufstelleRS,
                private $log: ILogService, private errorService: ErrorService,
                private $window: IWindowService, private $state: IStateService,
                private passwordStrengthService: PasswordStrengthService, $scope: IScope,
                private roleUtilService: RoleUtilService, private $translate: ITranslateService,
                private benutzerRS: BenutzerRS) {

        super($scope);

    }

    $onInit() {
        super.$onInit();
        this.initialModel = this.benutzer;
        this.model = angular.copy(this.benutzer);

    }

    private initModel() {
        //unused
        let benutzer: TSBenutzer = this.initialModel;

        if (benutzer && benutzer.roles.length === 0) {
            //wenn wir keine rollen haben setzen wir mal eine
            benutzer.roles.push(TSRole.UNASSIGNED_ROLE);

        }

    }

    public submit() {
        if (this.form.$valid && this.anlaufstelle && this.benutzer && this.checkEmailRepeated()) {

            this.benutzerRS.createOrUpdateBenutzeraccount(this.benutzer).then((storedBenutzer: TSBenutzer) => {
                if (storedBenutzer !== undefined) {
                    if (this.benutzer.isNew()) {
                        // this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                        this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', this.benutzer.email);
                    } else {
                        if (this.benutzer.email !== storedBenutzer.email) {
                            this.errorService.addMesageAsInfoWithArgs('BENUTZER_UPDATE_EMAIL_INFO', this.benutzer.email);
                        }
                    }
                    this.benutzer = storedBenutzer;
                    this.form.$setPristine();
                    this.form.$setUntouched();
                    this.$state.go('benutzerverwaltunganlaufstelle');
                } else {
                    this.$log.error('could not save new benutzer for anlaufstelle ' + this.anlaufstelle);
                }

            });

        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelBenutzeredit() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();

    }

    public getRoles(): Array<TSRole> {
        return this.roleUtilService.getAnlaufstelleSubuserRolesOnly();

    }

    public translateRole(val: TSRole): string {
        return this.$translate.instant(rolePrefix() + val);
    }

    private checkEmailRepeated(): boolean {
        let repeatValid = this.benutzer.checkEmailRepeated();
        if (!repeatValid) {
            this.errorService.addMesageAsError('ERROR_EMAIL_SAME');
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerEditAnlaufstelleView/benutzerEditAnlaufstelleView.ts